import store from './store';

const env = process.env || {
    "REACT_APP_API": 'https://dev-towplus-01.celanese.com/api',
    "REACT_APP_OKTA_SAML_URL": "https://dev-508930.oktapreview.com/app/tadigitaldev508930_towplussaml_1/exkgpd9n9iWf8AGxe0h7/sso/saml"
};

/* API CONFIGURATION */
const baseURL = env['REACT_APP_API'];

/* API ENDPOINTS */
const API = {
    baseURL: baseURL,
    myTowItems: '/my-towitems',
    towItems: '/towitems',
    importTowItems: '/towitems/import',
    exportTowItems: '/towitems/export?format=json',
    validateExcel: '/towitems/validateexcel',
    companies: '/companies',
    exportCompanies: '/companies/export',
    updateCompanies: '/companies/:id',
    cloneCompany: '/company-clone/:id',
    updateCloneCompany: '/companies/:id/clone-from/:fromId',
    epdBias: '/epdbias',
    epdBiasById: '/epdbias/:id',
    preferences: '/preferences',
    updatePreferences: '/preferences/:id',
    getMyPreferences: '/my-preferences',
    plugwrap: '/plugwrap',
    plugwrapId: '/plugwrap/:id',
    plants: '/plants',
    updatePlants: '/plants/:id',
    admin: '/logs',
    filters: '/filter-brands',
    filtersByName: '/filter-brands/:id',
    carbonFilters: '/carb-filter-brands',
    carbonFiltersByName: '/carb-filter-brands/:id',
    isRegisteredEmail: '/registered-emails',
    shareEntity: '/share-entity',
    cigarette: '/cig-brands',
    cigaretteById: '/cig-brands/:id',
    carbonCigarette: '/carb-cig-brands',
    carbonCigaretteById: '/carb-cig-brands/:id',
    manageMessages: '/messages',
    manageMessagesById: '/messages/:id',
    manageUsers: '/users',
    manageUsersLinkToExternal: '/users/link-to-azure',
    manageUsersById: '/users/:id',
    updateUserRoleAndCompany: '/update-user-role-company',
    languageTranslations: '/translations',
    languageTranslationsById: '/translations/:id/json',
    importTranslation: '/translations/import',
    exportTranslations: '/translations/export',
    languageCodes: '/translations/codes',
    addNewLanguage: '/translations/new-language',
    deleteLanguage: '/translations/delete-language',
    sendInvitation: '/send-invitation',
    sendAzureInvitation: '/send-azure-invitation',
    sendCEInvitation: '/send-ce-invitation',
    changePassword: '/change-password',
    signInList: '/sign-ins',
    countryNames: '/country-names',
    getAnalytics: '/get-analytics',

    getAzureGroups: '/get-azure-groups',
    setAzureGroup: '/set-azure-group',
    getAzureGroupMembers: '/get-azure-group-members',
    getRequestAccess: '/request-access'
};

const locale = navigator.language || navigator.userLanguage || navigator.browserLanguage;
export const utils = {
    isUSRegion() {
        if (locale) {
            try {
                const number = 1.1; // to know the decimal
                return (new Intl.NumberFormat(locale).format(number).indexOf(',') >= 0) ? false : true;
            } catch (e) {
                // error - swallow
            }
        }
        return true;
    },
    getTranslationText(translationKey, defaultText) {
        const { languagesState } = store.getState();
        if (languagesState && languagesState.translationData) {
            return languagesState.translationData[translationKey] || defaultText;
        }
        return defaultText;
    }
};


/* OKTA CONFIGURATION */
// const oktaDefaults = {
//     url: 'https://celanese.oktapreview.com',
//     clientId: '0oagnu7g1i164EhF30h7',
//     redirectUri: window.location.origin + 'x',
//     issuer: 'https://celanese.oktapreview.com/oauth2/default'
// };


// const oktaDefaults = {
//     url: 'https://techaspect-muralikrishnat.okta.com',
//     clientId: '0oa2nh19s3GdqBmw2356',
//     redirectUri: window.location.origin + '/authorization-code/callback',
//     issuer: 'https://techaspect-muralikrishnat.okta.com'
// };

// export default {
//     API,
//     oktaClient: (new window.OktaAuth(oktaDefaults))
// };


export default {
    API,
    oktaSamlUrl: env['REACT_APP_OKTA_SAML_URL'] || "https://dev-508930.oktapreview.com/app/tadigitaldev508930_towplussaml_1/exkgpd9n9iWf8AGxe0h7/sso/saml",
    AzureAD: {
        loginRequest: {
            scopes: ["openid", "profile"]
        }
    }
};


// WEBPACK FOOTER //
// ./src/config.js